import userApi from '@editor/api/user';
import { QueryKeys } from '@editor/queries/queryKeys';
import { BasicUserInfoResponse } from '@editor/types';
import { isApiError, QueryError } from '@repo/transport/queries';
import { getProfileToken } from '@repo/transport/token';
import { UseQueryOptions } from '@tanstack/react-query';

export type BasicUserInfoQueryData = BasicUserInfoResponse | null;

const basicUserInfoQuery: UseQueryOptions<BasicUserInfoQueryData> = {
  queryKey: [QueryKeys.BasicUserInfo],
  queryFn: async (): Promise<BasicUserInfoQueryData> => {
    const profileToken = getProfileToken();

    if (!profileToken) {
      return null;
    }

    const response = await userApi.getBasicUserInfo(profileToken);

    if (!response.success) {
      if (response.error && isApiError(response.error)) {
        throw new QueryError(response.error);
      }

      throw Error(`Failed to get basic user info: ${response.error}`);
    }

    return response;
  },
};

export default basicUserInfoQuery;
